export const NOTIFICATION_REFRESH_RATE = 60000;
